exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".main-menu{position:fixed;top:0;left:0;height:70px;color:#fff;z-index:10;background:#fff}.main-menu .main-menu-center,.main-menu .main-menu-center .main-menu-block{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.main-menu .main-menu-center .main-menu-block{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.main-menu .main-menu-center .main-menu-right{-webkit-box-flex:1;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);

// exports
